/**
 * 调试页面 - 用于检查 Assessment 数据结构
 */

import { useParams } from "react-router-dom";
import { useCarePlan } from "@/hooks/useCarePlan";

export function DebugAssessmentPage() {
  const { id } = useParams<{ id: string }>();
  const { timeline, assessment, isLoading, isUnlocked, error } = useCarePlan({
    assessmentId: id || "",
    enabled: !!id,
  });

  if (isLoading) {
    return <div className="p-8">加载中...</div>;
  }

  if (error) {
    return <div className="p-8 text-red-500">错误: {error}</div>;
  }

  return (
    <div className="p-8 space-y-4">
      <h1 className="text-2xl font-bold">调试信息</h1>

      <div className="space-y-2">
        <h2 className="text-xl font-semibold">基本信息</h2>
        <pre className="bg-gray-100 p-4 rounded overflow-auto">
          {JSON.stringify(
            {
              assessmentId: id,
              hasAssessment: !!assessment,
              hasTimeline: !!timeline,
              isUnlocked,
            },
            null,
            2
          )}
        </pre>
      </div>

      <div className="space-y-2">
        <h2 className="text-xl font-semibold">Timeline 数据</h2>
        <pre className="bg-gray-100 p-4 rounded overflow-auto max-h-96">
          {JSON.stringify(timeline, null, 2)}
        </pre>
      </div>

      <div className="space-y-2">
        <h2 className="text-xl font-semibold">Assessment 数据</h2>
        <pre className="bg-gray-100 p-4 rounded overflow-auto max-h-96">
          {JSON.stringify(assessment, null, 2)}
        </pre>
      </div>

      <div className="space-y-2">
        <h2 className="text-xl font-semibold">按钮显示条件</h2>
        <div className="bg-yellow-100 p-4 rounded">
          <p>
            isUnlocked: <strong>{String(isUnlocked)}</strong>
          </p>
          <p>
            应该显示按钮: <strong>{String(!isUnlocked)}</strong>
          </p>
          <p>
            timeline?.unlock_status:{" "}
            <strong>{JSON.stringify(timeline?.unlock_status)}</strong>
          </p>
        </div>
      </div>
    </div>
  );
}

export default DebugAssessmentPage;
